module.exports = __webpack_public_path__ + "img/MX-C130095B-BE-HQ.197cf569.png";